import { combineReducers } from 'redux';

import isNotificationLoading from './isNotificationLoading';

export default combineReducers({
  isNotificationLoading,
});
